module.exports = __webpack_public_path__ + "static/media/temperature-anomalies.d8e8c3ff.png";